

document.querySelectorAll('header-menu details.mega-menu').forEach(menu => {
  const summary = menu.querySelector('summary');
  const caret = summary.querySelector('.icon-caret');

  // Hover open
  menu.addEventListener('mouseenter', () => {
    menu.setAttribute('open', true);
  });

  // Arrow click → toggle submenu only
  if (caret) {
    caret.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();

      if (menu.hasAttribute('open')) {
        menu.removeAttribute('open');
      } else {
        menu.setAttribute('open', true);
      }
    });
  }

  // Text click → redirect to menu URL
  summary.addEventListener('click', (e) => {
    if (e.target.closest('.icon-caret')) return; // ignore arrow click

    const url = summary.getAttribute('data-url');
    if (url) {
      window.location.href = url;
    }
  });
});

// Click outside close
document.addEventListener('click', (e) => {
  document.querySelectorAll('header-menu details.mega-menu').forEach(menu => {
    if (!menu.contains(e.target)) {
      menu.removeAttribute('open');
    }
  });
});
